import axios from 'axios'

export const getMemberInfo = async accountId =>
  axios.get(`/users/v1/accounts/${accountId}/me`)

export const updateMemberInfo = async ({ accountId, name }) =>
  axios.put(`/users/v1/accounts/${accountId}/me`, {
    name
  })
